import { Routes } from '@angular/router';
import { AuthGuard } from '@aeCore/guards/auth.guard';
import { loginGuard } from '@aeCore/guards/login.guard';
import { SetNewPasswordComponent } from '@aeModules/auth/set-new-password/set-new-password.component';
import { AdminShellComponent } from '@aeShared/layouts/admin-shell/admin-shell.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((m) => m.authRoutes),
    title: 'Auth',
    canActivate: [loginGuard],
  },
  {
    path: 'forgot-password-confirm/:token',
    component: SetNewPasswordComponent,
    title: 'Confirm Password',
  },
  {
    path: 'change-password',
    component: SetNewPasswordComponent,
    title: 'Change Password',
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: AdminShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.routes').then(
            (m) => m.dashboardRoutes,
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./modules/users/users.routes').then((m) => m.usersRoutes),
      },
      {
        path: 'partner-kyc',
        loadChildren: () =>
          import('./modules/partner-kyc/partner-kyc.routes').then(
            (m) => m.partnerKycRoutes,
          ),
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('./modules/transactions/transactions.routes').then(
            (m) => m.transactionsRoutes,
          ),
      },
      {
        path: 'fee-pricing',
        loadChildren: () =>
          import('./modules/fee-pricing/fee-pricing.routes').then(
            (m) => m.feePricingRoutes,
          ),
      },
      {
        path: 'country-lane-management',
        loadChildren: () =>
          import('./modules/country-lane-management/country-lane-management.routes').then(
            (m) => m.countryLaneManagementRoutes,
          ),
      },
      {
        path: 'fx-config',
        loadChildren: () =>
          import('./modules/fx-config/fx-config.routes').then(
            (m) => m.fxConfigRoutes,
          ),
      },
      {
        path: 'partners',
        loadChildren: () =>
          import('./modules/partners/partners.routes').then(
            (m) => m.partnersRoutes,
          ),
      },
      {
        path: 'partner-onboarding',
        loadChildren: () =>
          import('./modules/partner-onboarding/partner-onboarding.routes').then(
            (m) => m.partnerOnboardingRoutes,
          ),
      },
      {
        path: 'aml-compliance',
        loadChildren: () =>
          import('./modules/aml-compliance/aml-compliance.routes').then(
            (m) => m.amlComplianceRoutes,
          ),
      },
      {
        path: 'admin-users',
        loadChildren: () =>
          import('./modules/admin-users/admin-users.routes').then(
            (m) => m.adminUsersRoutes,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.routes').then(
            (m) => m.settingsRoutes,
          ),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'auth' },
];
